var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83398 22.9688V10.6875H23.1673V22.9688",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82812 17.6875C3.60659 17.6875 3.60659 16.2071 5.38505 16.2071C7.16351 16.2071 7.16351 17.6875 8.94197 17.6875C10.7204 17.6875 10.7204 16.2071 12.4989 16.2071C14.2774 16.2071 14.2774 17.6875 16.0558 17.6875C17.8343 17.6875 17.8343 16.2071 19.6127 16.2071C21.3912 16.2071 21.3912 17.6875 23.1697 17.6875",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.4844,
    y: 4.9375,
    width: 5.53125,
    height: 5.625,
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98438 5.64062C4.98438 4.11321 6.22259 2.875 7.75 2.875C9.27741 2.875 10.5156 4.11321 10.5156 5.64062V10.5625H4.98438V5.64062Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.375H10.4375",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatering);
export default __webpack_public_path__ + "static/media/catering.33a7e9ebfbfe57cf936807d29087d56f.svg";
export { ForwardRef as ReactComponent };